import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
//import bootstrap 5
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; //Optional default CSS

import VueSocialSharing from 'vue-social-sharing'

import Vue3Tour from 'vue3-tour'
import 'vue3-tour/dist/vue3-tour.css'

import { createGtm } from "vue-gtm";

import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css'
import ContextMenu from '@imengyu/vue3-context-menu'

//instance app
const app = createApp(App);
app.use(VueSweetalert2);
app.use(SimpleTypeahead);
app.use(VueSocialSharing);
app.use(Vue3Tour);
app.use(
  createGtm({
    id: "GTM-WXFPZS4", 
    defer: false, 
    compatibility: false, 
    enabled: true,
    trackOnNextTick: false, 
  })
);
app.use(ContextMenu);
app.use(store).use(router).mount('#app')
